import { render, staticRenderFns } from "./the-honor-card.vue?vue&type=template&id=b8c10762&scoped=true&"
import script from "./the-honor-card.vue?vue&type=script&lang=js&"
export * from "./the-honor-card.vue?vue&type=script&lang=js&"
import style0 from "./the-honor-card.vue?vue&type=style&index=0&id=b8c10762&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8c10762",
  null
  
)

export default component.exports